import { getRequest, patchRequest, postRequest, putRequest } from "utils/helpers/common/http-methods";

export const USER_APIS = {
  getUsers: (params: any) => getRequest("/users", params),
  getUserById: (id: number) => getRequest(`/auth/user/${id}/details`),
  getEventById: (params: any) => getRequest(`/event/get`, params),
  getAllEvents: (params: any) => getRequest(`/event/get`, params),
  getEventDetailById: (eventId: number) => getRequest(`/event/${eventId}/details`),
  getMinorById: (params: any) => getRequest('/attendee/minors', params),
  getFavoriteHostById: (params: any) => getRequest('/host/favorite-hosts', params),
  getCommunityMessageById: (params: any) => getRequest(`/event/${params.eventId}/messages`, params),
  getSubscriptionPlan: () => getRequest('/stripe/products'),
  getSubscribers: (params: any) => getRequest('/host/subscribed-hosts', params),
  getCogbyHostId: (hostId: any) => getRequest(`/cup-of-gratitue/host/${hostId}`),
  getReviewsbyHostId: (hostId: number, params: any) => getRequest(`/host/reviews/${hostId}`, params),
  addTimeSlots: (id: number, body: any) => postRequest(`/team/add-available-slots${id}`, body),
  getActivities: (params: any) => getRequest('/ambassador/activities', params),
  getTeamRequests: (params: any) => getRequest('/team/ambassador/requests', params),
  approveRequest: (ambassadorId: number, body:any) => postRequest(`/team/approve-ambassador/${ambassadorId}`, body),
  getUserBadges: (params: any) => getRequest("/users/my/awarded/badges", params),
  getActivitiesEarnedPoints: (params: any) => getRequest("/ambassador/activities/points-earned", params),
  getProductRequest: (params: any) => getRequest("/ambassador/product-requests", params),
  activateUser: (userId: number) => patchRequest(`users/${userId}/enable`, {}),
  deactivateUser: (userId: number) => patchRequest(`users/${userId}/disable`, {}),
  getAmbassadorExperiences: (params: any) => getRequest("admin-events", params),
  addAmbassadorExperience: (body: any) => postRequest(`/admin-events`, body),
  uploadFile: (params: any) => postRequest("/file/upload", params),
  getAmbassadorExperienceById: (id: number) => getRequest(`/admin-events/${id}`),
  getAmbassadorCommunityMessages: (id: number, params?: any) => getRequest(`/admin-events/${id}/messages`, params),
  postAmbassadorCommunityMessages: (id: number, body: any) => postRequest(`/admin-events/${id}/messages`, body),
  markAttendanceAmbassadorExperience : (id:number, body:any) => putRequest(`/admin-events/${id}/attendance/bulk`, body),
};
